import { useCallback, useEffect, useRef, useState } from 'react';

type Destructor = () => void;

export function useDelayed<TArgs extends Array<any>>(operation: (...args: TArgs) => void | Destructor, delay = 2000) {
  const [timer, setTimer] = useState<NodeJS.Timeout>();
  const cleanupFunction = useRef<Destructor | null | void>(null);
  const delayedOperation = useCallback(
    (...args: TArgs) => {
      const newTimer = setTimeout(() => {
        cleanupFunction.current?.();
        cleanupFunction.current = operation(...args);
      }, delay);
      setTimer(newTimer);
    },
    [operation, delay]
  );

  useEffect(
    () => () => {
      if (timer) {
        // clear timer
        clearTimeout(timer);
        cleanupFunction?.current?.();
      }
    },
    [timer]
  );
  return delayedOperation;
}
